// extracted by mini-css-extract-plugin
export default {"maincontainer":"User_maincontainer__hFcKN","header":"User_header__WOuOF","btn_color":"User_btn_color__DFYxs","btn_colordis":"User_btn_colordis__I24dO","holder":"User_holder__MjyIZ"};